module.exports = __webpack_public_path__ + "static/media/sunshine.702e76d4.webp";